<template>
    <el-select v-model="selected" @change="onChange" clearable filterable>
        <el-option :key="i" :label="option[labelKey]" :value="option[valueKey]" v-for="(option, i) in optionArr"></el-option>
    </el-select>
</template>

<script>
    export default {
        name: "RemoteSelect",
        props: ["url", "labelName", "valueName", "options", "value"],
        data() {
            return {
                optionArr: this.options,
                selected: this.value
            }
        },
        watch: {
            value(val) {
                this.selected = val;
            },
            options(val) {
                this.optionArr = val;
            }
        },
        computed: {
            labelKey() {
                if (this.labelName) {
                    return this.labelName;
                } else if (this.url) {
                    return "name";
                } else {
                    return "label";
                }
            },
            valueKey() {
                if (this.valueName) {
                    return this.valueName;
                } else if (this.url) {
                    return "id";
                } else {
                    return "value";
                }
            }
        },
        mounted() {
            if (this.url) {
                this.$axios.post(this.url).then(response => {
                    this.optionArr = response.data;
                })
            }
        },
        methods: {
            onChange(val) {
                this.$emit('input', val);
                this.$emit('change', val);
            }
        }
    }
</script>